import { render } from "./FooterUI.vue?vue&type=template&id=3c3e0f06"
import script from "./FooterUI.vue?vue&type=script&lang=js"
export * from "./FooterUI.vue?vue&type=script&lang=js"

import "./FooterUI.vue?vue&type=style&index=0&id=3c3e0f06&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__